import request from "root/js/request";

export const  getDeductionDetailization = async ({
  cabinet_id__in,
  date_from,
  date_to,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/deduction_detailization/",
    method: "get",
    params: {
      cabinet_id__in,
      date_from,
      date_to,
      ...rest,
    },
  });
  return response.data;
};
